import React from 'react';
import { Link } from 'react-router-dom';
import { FaTruck, FaPhone, FaEnvelope, FaMapMarkerAlt, FaClock } from 'react-icons/fa';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-grid">
          <div className="footer-column">
            <div className="footer-logo">
              <FaTruck className="footer-logo-icon" />
              <span className="footer-logo-text">
                <span className="footer-logo-main">Toronto Roadside</span>
                <span className="footer-logo-sub">Assistance</span>
              </span>
            </div>
            <p className="footer-description">
              Professional towing and roadside assistance services available 24/7 throughout Toronto. 
              When you need help, we're just a call away.
            </p>
          </div>

          <div className="footer-column">
            <h3 className="footer-title">Quick Links</h3>
            <ul className="footer-links">
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/services">Services</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>

          <div className="footer-column">
            <h3 className="footer-title">Our Services</h3>
            <ul className="footer-links">
              <li><Link to="/services#towing">Towing Services</Link></li>
              <li><Link to="/services#battery">Battery Boost</Link></li>
              <li><Link to="/services#lockout">Lock Out Service</Link></li>
              <li><Link to="/services#tire">Tire Change</Link></li>
            </ul>
          </div>

          <div className="footer-column">
            <h3 className="footer-title">Contact Info</h3>
            <ul className="footer-contact">
              <li>
                <FaPhone className="footer-icon" />
                <a href="tel:6478988242">(647) 898-8242</a>
              </li>
              <li>
                <FaEnvelope className="footer-icon" />
                <a href="mailto:raymond@torontoroadside.ca">raymond@torontoroadside.ca</a>
              </li>
              <li>
                <FaMapMarkerAlt className="footer-icon" />
                <span>Toronto, Ontario</span>
              </li>
              <li>
                <FaClock className="footer-icon" />
                <span>24/7 Emergency Service</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="footer-bottom-content">
          <p>&copy; {new Date().getFullYear()} Toronto Roadside Assistance. All rights reserved.</p>
          <p className="footer-tagline">Your trusted partner on the road.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

